export default __webpack_public_path__ + "static/media/delete.53c9f4b6.svg";